export const CONNECTOR_TYPES = Object.freeze({
    yClients: 'yClients',
    alfa: 'alfa',
    planfact: 'planfact',
    zenmoney: 'zenmoney',
    universeSoft: 'universeSoft',
    profSalon: 'profSalon',
    GCB: 'GCB',
    GCB2: 'GCB2',
    sycret: 'sycret',
    sonline: 'sonline',
    arnica: 'arnica',
    arnicaV2: 'arnicaV2',
    moiSklad: 'moiSklad',
    helix1C: 'helix1C',
    lenaLenina: 'lenaLenina',
    mango: 'mango',
    chat2desk: 'chat2desk',
    whatsapp: 'whatsapp',
    profSalonBat: 'profSalonBat',
    profSalonBatV2: 'profSalonBatV2',
    altegio: 'altegio',
    dikidi: 'dikidi',
    archimed: 'archimed',
    telephonyMegaphone: 'telephonyMegaphone',
    telephonyProstyiZvonki: 'telephonyProstyiZvonki',
    telephonyBeeline: 'telephonyBeeline',
    telephonyMango: 'telephonyMango',
    telegramHr: 'telegramHr',
    telegramHrBranch: 'telegramHrBranch',
    sipuni: 'sipuni',
    amoCrm: 'amoCrm',
    amoCrmFull: 'amoCrmFull',
    ruslan1C: 'ruslan1C',
    dentalPro: 'dentalPro',
    vpn1C: 'vpn1C',
    klientix: 'klientix',
    cloud1C: 'cloud1C',
    klatch: 'klatch',
    maxBusiness: 'maxBusiness',
    whatsappBasis: 'whatsappBasis',
    prostoSMS: 'prostoSMS',
    pbxOnline: 'pbxOnline',
    waitThai: 'waitThai',
})

// Типы провайдеров
export const PROVIDER_TYPES = Object.freeze({
    whatsappBasis: 'whatsappBasis',
    whatsappApi: 'whatsappApi',
    telegramApi: 'telegramApi',
    telegramDh: 'telegramDh',
    maxBasis: 'maxBasis',
    maxDh: 'dh-max',
    maxBusiness: 'maxBusiness',
    smsGate: 'smsGate',
    whatsapp: 'whatsapp',
    whatsappDh: 'dh-whatsapp',
})
export const CHANNEL_TYPES = Object.freeze({
    whatsappChannel: 'whatsappChannel',
    telegramChannel: 'telegramChannel',
    maxChannel: 'maxChannel',
    maxBusiness: 'maxBusiness',
    smsChannel: 'smsChannel',
})

// Маппинг провайдеров на типы каналов
export const PROVIDER_TO_CHANNEL_MAP = Object.freeze({
    [PROVIDER_TYPES.whatsappBasis]: CHANNEL_TYPES.whatsappChannel,
    [PROVIDER_TYPES.whatsappApi]: CHANNEL_TYPES.whatsappChannel,
    [PROVIDER_TYPES.whatsapp]: CHANNEL_TYPES.whatsappChannel,
    [PROVIDER_TYPES.whatsappDh]: CHANNEL_TYPES.whatsappChannel,
    [PROVIDER_TYPES.telegramApi]: CHANNEL_TYPES.telegramChannel,
    [PROVIDER_TYPES.telegramDh]: CHANNEL_TYPES.telegramChannel,
    [PROVIDER_TYPES.maxBasis]: CHANNEL_TYPES.maxChannel,
    [PROVIDER_TYPES.maxDh]: CHANNEL_TYPES.maxChannel,
    [PROVIDER_TYPES.maxBusiness]: CHANNEL_TYPES.maxBusiness,
    [PROVIDER_TYPES.smsGate]: CHANNEL_TYPES.smsChannel,
})

// Обратный маппинг для обратной совместимости (старые названия)
export const PROVIDER_TYPES_LEGACY = Object.freeze({})
//Типы коннекторов, которые поддерживают GCB и GCB2
export const GCB_EXTERNAL_CONNECTOR_TYPES = Object.freeze([
    CONNECTOR_TYPES.yClients,
    CONNECTOR_TYPES.universeSoft,
    CONNECTOR_TYPES.profSalon,
    CONNECTOR_TYPES.sycret,
    CONNECTOR_TYPES.sonline,
    CONNECTOR_TYPES.arnica,
    CONNECTOR_TYPES.arnicaV2,
    CONNECTOR_TYPES.moiSklad,
    CONNECTOR_TYPES.helix1C,
    CONNECTOR_TYPES.lenaLenina,
    CONNECTOR_TYPES.mango,
    CONNECTOR_TYPES.chat2desk,
    CONNECTOR_TYPES.altegio,
    CONNECTOR_TYPES.profSalonBat,
    CONNECTOR_TYPES.profSalonBatV2,
    CONNECTOR_TYPES.dikidi,
    CONNECTOR_TYPES.archimed,
    CONNECTOR_TYPES.ruslan1C,
    CONNECTOR_TYPES.dentalPro,
    CONNECTOR_TYPES.vpn1C,
    CONNECTOR_TYPES.amoCrmFull,
    CONNECTOR_TYPES.klientix,
    CONNECTOR_TYPES.cloud1C,
    CONNECTOR_TYPES.klatch,
    CONNECTOR_TYPES.waitThai,
])
export const TELEPHONY_CONNECTOR_TYPES = Object.freeze([
    CONNECTOR_TYPES.telephonyMegaphone,
    CONNECTOR_TYPES.telephonyProstyiZvonki,
    CONNECTOR_TYPES.sipuni,
    CONNECTOR_TYPES.telephonyBeeline,
    CONNECTOR_TYPES.telephonyMango,
    CONNECTOR_TYPES.pbxOnline
])
export const MESSAGING_CONNECTOR_TYPES = Object.freeze([
    CONNECTOR_TYPES.whatsapp,
    CONNECTOR_TYPES.whatsappBasis,
    CONNECTOR_TYPES.telegramHr
])
export const PENDING_CONNECTOR_TYPES = Object.freeze([
    CONNECTOR_TYPES.profSalonBat,
    CONNECTOR_TYPES.arnicaV2,
    CONNECTOR_TYPES.altegio,
    CONNECTOR_TYPES.dentalPro,
])
export const DECLINATION_SHORT_MONTH_NAMES = Object.freeze({
    'янв.': 'январе',
    'февр.': 'феврале',
    март: 'марте',
    'апр.': 'апреле',
    май: 'мае',
    июнь: 'июне',
    июль: 'июле',
    'авг.': 'августе',
    'сент.': 'сентябре',
    'окт.': 'октябре',
    'нояб.': 'ноябре',
    'дек.': 'декабре',
})
export const TAG_COLORS = Object.freeze(['#A5C94B', '#FD9060', '#BA7EC6', '#5EA0E3'])

export const OUT_OF_SYNC_ERROR_TEXT = `Данные устарели, перезагрузите страницу и повторите действие`
export const NETWORK_ERROR_TEXT = `Возникла проблема с подключением к серверу. Пожалуйста, проверьте свое интернет-соединение, нажмите ОК, перезагрузите страницу и повторите действие.`
